import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Vendor.css';

function Vendor() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    company: '',
    street: '',
    city: '',
    state: '',
    postal_code: '',
    first_name: '',
    last_name: '',
    email: '',
    phone1: '',
    phone2: '',
    fax: '',
    website: '',
    comments: '',
    supplier_code: '',
    due: '0',
    over_payment: '0',
    opening_date: '',
    Ledger: '',
    IsSend: false,
  });
  const [status, setStatus] = useState('');
  const [error, setError] = useState('');

  const handleChange = (field) => (event) => {
    const value = field === 'IsSend' ? event.target.checked : event.target.value;
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus('');
    setError('');

    try {
      const token = localStorage.getItem('token');
      await axios.post('/api/vendors', form, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setStatus('Vendor saved successfully.');
      setTimeout(() => {
        navigate('/vendors');
      }, 1200);
    } catch (err) {
      setError(
        err.response?.data?.error ||
        err.response?.data?.message ||
        (err.response?.data?.errors && err.response.data.errors[0]?.msg) ||
        'Failed to save vendor.'
      );
    }
  };

  return (
    <div className="vendor-page">
      <button className="back-link" onClick={() => navigate('/vendors')}>
        New Vendor
      </button>

      <div className="vendor-card">
        <p className="vendor-note">Enter vendor information below and save to return to the vendor list page.</p>

        <form className="vendor-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <label>Company</label>
            <input value={form.company} onChange={handleChange('company')} placeholder="Company name" required />
          </div>

          <div className="form-row">
            <label>Street</label>
            <input value={form.street} onChange={handleChange('street')} placeholder="Street address" />
          </div>

          <div className="form-grid three-columns">
            <div className="form-row">
              <label>City</label>
              <input value={form.city} onChange={handleChange('city')} placeholder="City" />
            </div>
            <div className="form-row">
              <label>State</label>
              <input value={form.state} onChange={handleChange('state')} placeholder="State / Country" />
            </div>
            <div className="form-row">
              <label>Postal Code</label>
              <input value={form.postal_code} onChange={handleChange('postal_code')} placeholder="Postal code" />
            </div>
          </div>

          <div className="form-grid two-columns">
            <div className="form-row">
              <label>First Name</label>
              <input value={form.first_name} onChange={handleChange('first_name')} placeholder="First name" />
            </div>
            <div className="form-row">
              <label>Last Name</label>
              <input value={form.last_name} onChange={handleChange('last_name')} placeholder="Last name" />
            </div>
          </div>

          <div className="form-grid two-columns">
            <div className="form-row">
              <label>Email</label>
              <input type="email" value={form.email} onChange={handleChange('email')} placeholder="Email" />
            </div>
            <div className="form-row">
              <label>Website</label>
              <input value={form.website} onChange={handleChange('website')} placeholder="Website" />
            </div>
          </div>

          <div className="form-grid three-columns">
            <div className="form-row">
              <label>Phone 1</label>
              <input value={form.phone1} onChange={handleChange('phone1')} placeholder="Primary phone" />
            </div>
            <div className="form-row">
              <label>Phone 2</label>
              <input value={form.phone2} onChange={handleChange('phone2')} placeholder="Secondary phone" />
            </div>
            <div className="form-row">
              <label>Fax</label>
              <input value={form.fax} onChange={handleChange('fax')} placeholder="Fax" />
            </div>
          </div>

          <div className="form-grid three-columns">
            <div className="form-row">
              <label>Supplier Code</label>
              <input value={form.supplier_code} onChange={handleChange('supplier_code')} placeholder="Supplier code" />
            </div>
            <div className="form-row">
              <label>Due</label>
              <input type="number" step="0.01" value={form.due} onChange={handleChange('due')} placeholder="0.00" />
            </div>
            <div className="form-row">
              <label>Over Payment</label>
              <input type="number" step="0.01" value={form.over_payment} onChange={handleChange('over_payment')} placeholder="0.00" />
            </div>
          </div>

          <div className="form-grid two-columns">
            <div className="form-row">
              <label>Opening Date</label>
              <input type="date" value={form.opening_date} onChange={handleChange('opening_date')} />
            </div>
            <div className="form-row">
              <label>Ledger</label>
              <input value={form.Ledger} onChange={handleChange('Ledger')} placeholder="Ledger code" />
            </div>
          </div>

          <div className="form-row">
            <label>Comments</label>
            <textarea value={form.comments} onChange={handleChange('comments')} placeholder="Comments" rows="4" />
          </div>

          <label className="vendor-checkbox">
            <input type="checkbox" checked={form.IsSend} onChange={handleChange('IsSend')} />
            Is Send
          </label>

          {error && <div className="form-error">{error}</div>}
          {status && <div className="form-success">{status}</div>}

          <button type="submit" className="save-btn">Save Vendor</button>
        </form>
      </div>
    </div>
  );
}

export default Vendor;
